import gql from "graphql-tag";
import { vehiclesDetailsFields } from "../queries/getVehicles";


export const UPSERT_VEHICLE = gql`mutation upsertVehicle($vehicleInputData: VehicleInput) {
    upsertVehicle(vehicleInputData: $vehicleInputData) {
        ${vehiclesDetailsFields}
    }
}`;